/**
 * Exports an array of row objects to a CSV file download.
 *
 * @param filename  Suggested download filename (e.g. "search-funnel.csv")
 * @param rows      Array of flat objects with string or number values
 * @param columns   Column definitions — determines order and display headers
 */
export function exportToCsv(
  filename: string,
  rows: Record<string, string | number>[],
  columns: { key: string; label: string }[]
): void {
  const header = columns.map((c) => JSON.stringify(c.label)).join(',');
  const body = rows
    .map((row) =>
      columns
        .map((c) => {
          const val = row[c.key] ?? '';
          return typeof val === 'string' ? JSON.stringify(val) : String(val);
        })
        .join(',')
    )
    .join('\n');

  // UTF-8 BOM ensures Excel opens non-ASCII characters correctly
  const csv = `\uFEFF${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  // Anchor must be in the DOM for Firefox/Safari compatibility
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
